
import dayjs from 'dayjs';
import Api from '@/utils/api';
import MHeader from '../../Header/Header.vue';
import NotData from '../../NoData/NoData.vue';
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
components: {
Tab,
TabItem,
Swiper,
SwiperItem,
MHeader,
ViewBox,
NotData,
XImg,
XButton
},
created() {
this.getCouponsList()
},
data() {
return {
couponList: [],
tabList: ['全部', '未使用', '已使用'],
tabIndex: 0
}
},
mounted() {
},
methods: {
couponExpired(item) {
return dayjs().isAfter(dayjs(item.expirationDate).endOf('day'))
},
getCouponsList() {
let filter = {
status: ''
}
switch (this.tabIndex) {
case 1:
filter.status = 'unused'
break
case 2:
filter.status = 'used'
break
case 0:
default:
filter.status = ''
}
Api.getCouponsList(filter)
.then(res => {
this.couponList = res.data
})
},
tabTap(res) {
this.getCouponsList()
},
back() {
this.$router.replace({
name: 'userCenter'
});
},
useCoupon(coupon) {
console.log(coupon)
this.$router.push({
name: 'recommend',
query: {
coupon: JSON.stringify(coupon)
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/UserCenter/couponList/couponList.vue